import Vue from 'vue'
// import VueSocketIO from 'vue-socket.io'
// import SocketIO from 'socket.io-client'

// Vue.use(new VueSocketIO({
//   debug: true,
//   connection: SocketIO('/socket.io'),
//   options: {
//     autoConnect: false,
//     path: "/drama",
//     // query: {
//     //   auth_token: ''
//     // }
//   }
// }))

import websocket from './websocket'
Vue.prototype.$socket = websocket